<!--  -->
<template>
  <div class="index-banner" style="margin-top:0;">
      <!-- <div class="zhanwei" style="width:1240px;margin: 0 auto;text-align: right;padding: 14px 0;">
        <a style="display:inline-block;height:70px;padding-right:20px;" href="http://www.gov.cn/zhuanti/zggcddescqgdbdh/index.htm" target="_blank" class="dys_addLink">
          <img src="../../../../static/img/danghuiicon.png">
        </a>
      </div> -->
      <div class="index-banner-center">
        <div class="logo-wrapper">
          <div class="logo-left">
            <img src="/static/img/logo.png" alt>
          </div>
          <div class="logo-right">
            <div class="lr-img-box">
              <img src="/static/img/big-title.png" alt>
              <img class="logo-right-english" src="/static/img/small-title.png" alt>
            </div>
            <div class="lr-text-box">
              <img src="../../../../static/img/textlogo.png" alt="">
            </div>
            <div class="lang-switch">
              <span @click="langSwitch('E')" :class="languageActive==='E'?'languageActive':''">English</span>/
              <span @click="langSwitch('Z')" :class="languageActive==='Z'?'languageActive':''">中文</span>
            </div>
          </div>
        </div>
        
      </div>
      <div class="center">
        <div class="list">
          <a href="http://www.ncosm.org.cn/ncosm/zqyj" target="_blank">
          <div class="listImg"></div>
          <p class="title">征求意见系统</p>
          <p class="tip"></p>
          <p class="tip"></p>
          <p class="look">点击查看</p>
          </a>
        </div>
        <div class="list">
          <a href="http://www.ncosm.org.cn/ncosm/ttzxd" target="_blank">
          <div class="listImg"></div>
          <p class="title">制修订系统</p>
          <p class="tip"></p>
          <p class="tip"></p>
          <p class="look">点击查看</p>
          </a>
        </div>
      </div>
    </div>
</template>

<script>
import { userApi } from "@/api/user.js";
export default {
  data () {
    return {
      languageActive: "Z",  //当前使用语言
      titleList: [],
    }
  },
  methods:{
    //切换语言逻辑
    langSwitch(type){
      return;  //暂不开放
    },
    getBusinessList() {
      userApi.worksperiod().then(res => {
        this.titleList = res.data;
      });
    },
  },
  mounted(){
    this.getBusinessList();
  }
}

</script>
<style scoped>
.index-banner {
  width: 100%;
  height: 800px;
  background-image: url(/static/img/banner.png);
  background-size: 100% 100%;
  position: relative;
  margin-top: -200px;
}
.banner-line {
  width: 100%;
  height: 136px;
  background: url(/static/img/top-line.png) no-repeat center 68px;
  background-size: 2560px 40px;
  position: relative;
  margin-top: -100px;
}
.banner-line-grey {
  width: 100%;
  height: 3px;
  background: #b2b9c3;
  position: absolute;
  top: 100px;
  left: 0;
}
.banner-sanjiao {
  position: absolute;
  width: 860px;
  height: 34px;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  background: url(/static/img/sanjiao.png) no-repeat center right;
  background-size: 40px 34px;
}
.index-banner-center {
  width: 1240px;
  margin: 0 auto;
  padding: 40px 0 0 0;
}
.logo-wrapper {
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.logo-left {
  margin-right: 40px;
}
.logo-left img{
  width: 104px;
}
.logo-right{
  display: flex;
  /* align-items: flex-end; */
  justify-content: space-between;
}
.lr-img-box{
  width:555px;
}
.lr-text-box{
  width:308px;
  margin-left: 55px;
  margin-top: 20px;
}
.lr-text-box img{
  width:308px;
  height: 68px;
  display: block;
}
.logo-right .lr-img-box img{
  width: 555px;
}
.lang-switch{
  width: 195px;
  text-align: right;
  color: white;
  font-size: 20px;
  color: #71A7E8;
}
.lang-switch span{
  cursor: pointer;
}
.languageActive{
  color: #fff;
}
.logo-right-english {
  margin-top: 11px;
}
.nav-wrapper {
  margin-top: 40px;
}
.nav-header {
  width: 100%;
  height: 118px;
  background: url(/static/img/nav-bj.png) no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: nowrap;
  position: relative;
}
.nav-item {
  flex: 1;
  height: 100%;
  text-align: center;
  padding: 19px 0;
  box-sizing: border-box;
  cursor: pointer;
}
.hover-show {
  position: absolute;
  top: 118px;
  left: 0;
  width: 100%;
  background: #fff;
  padding: 25px 30px;
  box-sizing: border-box;
  display: none;
  overflow: hidden;
  z-index: 100;
}
.hover-show-item::after {
  position: absolute;
  content: " ";
  left: 0;
  top: 0;
  width: 8px;
  height: 100%;
}
.hover-show-item {
  font-size: 18px;
  line-height: 30px;
  padding: 5px 0;
  box-sizing: border-box;
  border-left: 8px solid #b9c4dd;
  color: #b9c4dd;
  float: left;
  margin-right: 40px;
  position: relative;
  padding-left: 10px;
  cursor: pointer;
  text-align: left;
  margin-bottom: 10px;
}
.hover-show-item:hover {
  border-left: 8px solid #265add;
  color: #265add;
}
.nav-item:hover {
  background: #085ccb;
}
.nav-item:hover .hover-show {
  display: block;
}
.nav-item:hover .dia-sanjiao {
  display: block;
}
.nav-item img {
  height: 40px;
  display: inline-block;
  margin: 0 auto;
}
.nav-item .text {
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  position: relative;
}
.dia-sanjiao {
  display: none;
  width: 0;
  height: 0;
  border-width: 0 10px 10px;
  border-style: solid;
  border-color: transparent transparent #fff; /*透明 透明  黄*/
  position: absolute;
  bottom: -18px;
  left: 50%;
  transform: translateX(-50%);
}
.slide-wrapper {
  display: flex;
  height: 432px;
}
.slide-wrapper-left {
  width: 731px;
  height: 100%;
  box-sizing: border-box;
  background: #fff;
}
.slide-wrapper-right {
  width: 509px;
  height: 100%;
  background: url(/static/img/banner-right-bj.png) no-repeat center;
  background-size: 100% 100%;
  position: relative;
  overflow: hidden;
}
/*新增悬浮窗口样式*/
.float-ad {
  position: fixed;
  width: 257px;
  height: 338px;
  bottom: 44px;
  right: 30px;
  background: url(/static/img/top-3.png) no-repeat center center;
  background-size: 257px 338px;
  padding: 38px 30px 0 33px;
  box-sizing: border-box;
  z-index: 111;
}
.float-ad-lenght1 {
  position: fixed;
  width: 257px;
  height: 246px;
  bottom: 200px;
  right:0;
  background: url(/static/img/top-4.png) no-repeat center center;
  background-size: 257px 246px;
  padding: 37px 30px 0 30px;
  box-sizing: border-box;
  z-index: 111;
}
/* .float-ad::after {
  content: "";
  position: absolute;
font-size: 0;
line-height: 0;
border-width: 13px;
border-color: rgba(255, 255, 255, 0.5);
border-right-width: 0;
border-style: dashed;
border-left-style: solid;
border-top-color: transparent;
border-bottom-color: transparent;
right: 21px;
bottom: 15px;

} */
/* .float-css-bg{
  width: 190px;
  padding:10px;
  box-sizing: border-box;
  height: 100%;
  background:rgba(255, 255, 255, 0.5);
  position: relative;
  border-radius: 5px;
  -webkit-border-radius:5px;
} */
.top-center {
  width: 174px;
  margin: 0 auto;
}
.gg-title {
  margin-top: -2px;
  width: 100%;
  height: 60px;
  background: #fff;
  position: relative;
  border-radius: 5px 5px 0 0;
}
.bgz-title {
  width: 229px;
  height: 60px;
  position: absolute;
  top: 0px;
  left: -29px;
  background: url(/static/img/top-1.png) no-repeat center center;
  background-size: 229px 60px;
  text-align: center;
  line-height: 50px;
  color: #ffffff;
  font-size: 20px;
}
.gg-list {
  margin-top: -16px;
}
.gg-list-item {
  background: #fff;
  margin-bottom: 8px;
  padding: 14px 17px;
  box-sizing: border-box;
}
.float-title {
  width: 100%;
  font-size: 14px;
  color: #112854;
  line-height: 16px;
  height: 32px;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.float-more {
  margin-top: 9px;
  margin-bottom: 0px;
  text-align: right;
  font-size: 12px;
  color: #112854;
  cursor: pointer;
}
.close-float {
  width: 174px;
  height: 34px;
  background: url(/static/img/top-2.png) no-repeat center center;
  background-size: 100% 100%;
  line-height: 34px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}
/*新增悬浮窗口样式*/
.add-more1 {
  width: 80px;
  height: 30px;
  background: url(/static/img/add-more1.png) no-repeat center center;
  background-size: 100% 100%;
  margin-left: 53px;
  box-sizing: border-box;
  cursor: pointer;
}
.add-more2 {
  margin-top: 25px;
  cursor: pointer;
  width: 80px;
  height: 30px;
  background: url(/static/img/add-more2.png) no-repeat center center;
  background-size: 100% 100%;
  margin-left: 28px;
  box-sizing: border-box;
}
.banner-slide-one {
  width: 100%;
  height: 432px;
}
.banner-slide-text {
  font-size: 22px;
  color: #fff;
  padding-right: 100px;
  line-height: 93px;
  padding-left: 26px;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  width: 100%;
  background: #000;
  opacity: 0.7;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.center{
  width: 1240px;
  margin: 100px auto;
  display: flex;
  justify-content: flex-start;
}
.center .list{
  width: 250px;
  height: 250px;
  background: #F2F6FC;
  margin-bottom: 50px;
  position: relative;
  margin-right: 50px;
}
.center .list a{
  width: 100%;
  height: 100%;
  display: block;
}
.center .list .listImg{
  width: 75px;
  height: 60px;
  background: url(../../../../static/img/1.1.png) no-repeat center;
  background-size: 100% 100%;
  margin: 20px auto;
}
.center .list .title{
  font-size: 20px;
  color: #000;
  text-align: center;
  margin-bottom: 20px;
  line-height: 22px;
}
.center .list .tip{
  font-size: 14px;
  line-height: 20px;
  color: #666666; 
  text-align: center;
}
.center .list .look{
  width: 80px;
  height: 30px;
  background: #045DCE;
  color: #fff;
  font-size: 14px;
  display: block;
  text-align: center;
  line-height: 30px;
  border-radius: 5px;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 20px;
}
.center .list:hover{
  background: url(../../../../static/img/9.png) no-repeat center;
  background-size: 100% 100%;
}
.center .list:hover .title,.center .list:hover .tip{
  color: #fff;
}
.center .list:hover .look{
  background: #fff;
  color: #045DCE;
}
.center .list:hover .listImg{
  background: url(../../../../static/img/8.png) no-repeat center;
  background-size: 100% 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/views/LinkPage/index.vue